//Actions 
export const ACTIVE_ADMIN = 'ACTIVE_ADMIN';
export const CLEAR_ADMIN  = 'CLEAR_ADMIN';

export function clearAdmin() {
  return (dispatch) => Promise.resolve(dispatch({ 
    type: CLEAR_ADMIN, 
    payload: null 
  }))

} // END clearToken


// WEBPACK FOOTER //
// ./src/redux/actions/adminActions.js